import * as React from 'react';
import ouiStyle from '@goldwasserexchange/oui-style';
import { useSetCurrentModalValue } from '../../../../../../../../Components/Modal';
import Accounts, { useAccountOrdersArDocModalName } from '../../../../../accounts';
import { FileIconModalButtonContainer } from './container';
import { ArDocFileIcon } from '../../fileIcon';

export const AccountOrdersFileIconModalButton = (props: {
  hasFileName?: boolean,
  size?: string | number | undefined,
  transform?: ouiStyle.InStyle['transform'],
  stroke?: ouiStyle.Constants.Colors,
}) => {
  const {
    hasFileName,
    transform,
    size,
    stroke,
  } = props;
  const {
    data,
  } = useAccountOrdersArDocModalName();
  const onClick = useSetCurrentModalValue(data ?? null, !hasFileName);
  return (
    <FileIconModalButtonContainer
      onClick={onClick}
      hasFileName={hasFileName}
      transform={transform}
    >
      <ArDocFileIcon
        service={Accounts.Orders}
        size={size}
        stroke={stroke}
      />
    </FileIconModalButtonContainer>
  );
};
